/**
 * component to render in terms and conditions tab at How to Nominate page EE
 */
const TermsAndConditions = (): React.ReactElement => {
  return (
    <div
      className="mb-5 bg-gray-150 p-4 pb-5 font-public-sans"
      data-testid="terms-and-conditions-component"
    >
      <p className="leading-[1.4]">
        By submitting an application for the Emerging Enterprise Award or the
        Emerging Enterprise Sustainability Award or the Most Promising Startup
        Award or the Most Promising Sustainability Startup Award (collectively,
        the “Awards”), we hereby declare that we have read, understood and agree
        to abide by the terms & conditions as follows:-
      </p>

      <ul className="list-outside list-decimal pl-8 leading-[1.4]">
        <li>
          We permit and authorise The Business Times, OCBC, RSM, Mastercard,
          A*STAR, Enterprise Singapore and Paia Consulting (the “organisers/
          sponsors”) to use and disclose all information, data and materials
          submitted in connection with us and the Awards, to contact us for the
          Award-related activities, conduct searches with any public registry or
          credit bureau, research and analysis which might involve third party
          researchers and the publication of a report by third parties.
        </li>

        <li>
          We agree and undertake to indemnify and hold the organisers /sponsors
          harmless against any claims, proceedings, damages, losses and costs
          (including legal fees on an indemnity basis) that may arise in
          connection with the breach of any terms, warranties and conditions
          herein or in the event that any representations and authorisation
          given in connection with the Awards are untrue or invalid.
        </li>

        <li>
          We agree that the organisers/sponsors shall not be liable for any
          damages, losses, costs, expenses, claims and liabilities (whether
          direct, indirect, special or consequential and whether foreseeable or
          not) arising out of or in connection with matters relating to the
          Awards.
        </li>

        <li>
          We agree upon the written request of the organisers/sponsors to
          provide clarification, supporting evidence and relevant company
          information should the organisers need to verify the data provided in
          the Emerging Enterprise Award or the Emerging Enterprise
          Sustainability Award application.
        </li>

        <li>
          We represent and warrant that all information provided by us pursuant
          to this application is true, correct and accurate as of the date of
          submission of the application.
        </li>

        <li>
          We agree, upon the written request of the organisers/sponsors to
          provide our actual and projected financial figures.
        </li>

        <li>
          We agree to notify the organisers/sponsors in the event of any changes
          to our eligibility for the Emerging Enterprise Award or the Emerging
          Enterprise Sustainability Award.
        </li>

        <li>
          We agree that the judges&apos; decision on all aspects of the Awards
          including the shortlist, evaluation and the publication of the list of
          the Emerging Enterprise Award or the Emerging Enterprise
          Sustainability Award Finalists will be final. The organisers/sponsors
          are not under any obligation whatsoever to provide any reason or
          explanation to us.
        </li>

        <li>
          We agree to notify the organiser/sponsor in the event that we, our
          parent company or any of our subsidiaries have applied for its shares
          to be listed for quotation on the official list of a securities
          exchange as defined in the Securities and Futures Act 2001 on or
          before the physical presentation of the Awards at an event organised
          by the organisers/ sponsors (&quot;Presentation Ceremony&quot;). In
          the event any of the organisers/ sponsors have been made aware that we
          have applied for our shares to be listed for quotation on the official
          list of a securities exchange as defined in the Securities and Futures
          Act 2001 on or before the Presentation Ceremony, we agree that our
          application will be deemed disqualified and any Award already granted
          prior to the Presentation Ceremony will be immediately revoked.
        </li>

        <li>
          We agree to provide details of any litigation cases against us and
          (where we are a company) our directors/shareholders/partners/sole
          proprietor in the run-up to the publication of the list of the Award
          Finalists.
        </li>

        <li>
          We agree to abide by the publicity schedules and guidelines stipulated
          by the organisers/sponsors in the run-up to and after the publication
          of the Emerging Enterprise Award or the Emerging Enterprise
          Sustainability Award Finalists, and we further agree that the
          organisers/sponsors have the discretion to amend such publicity
          schedules without prior notice to us.
        </li>

        <li>
          We consent to the use by any organisers/sponsors of our information
          provided to the organisers/sponsors (including, without limitation,
          our name, logos, photos and/or video shoot) and media interview
          articles to be used in any publicity and/or advertising materials of
          any organiser/sponsor.
        </li>

        <li>
          We agree to provide any relevant information requested by the
          organisers/sponsors in relation to us for purposes of inclusion in the
          Emerging Enterprise Award or the Emerging Enterprise Sustainability
          Award media promotions, press releases and marketing collateral.
        </li>

        <li>
          We agree to abide by the rules/standards as may be determined by the
          organisers/sponsors regarding the usage of the Emerging Enterprise
          Award or the Emerging Enterprise Sustainability Award logo.
        </li>

        <li>
          We agree that should we not accept any prize offered under the Awards
          by an organiser/sponsor, we shall forfeit all other prizes offered by
          the remaining organisers/sponsors.
        </li>

        <li>
          We agree that the Awards may be revoked by the organisers/sponsors in
          the event that the organisers/sponsors are of the view that we are in
          breach of any of the terms and conditions of the relevant Award.
        </li>

        <li>
          We agree and acknowledge that if we win any Award:
          <ul className="list-outside list-[lower-alpha] pl-8">
            <li>
              the interest-free loan to be received (whether by the winner or
              its newly-established subsidiary, partnership or sole
              proprietorship, as applicable) shall be subject to the following
              conditions:
              <ul className="list-outside list-[upper-roman] pl-8">
                <li>the term loan shall be an unsecured facility;</li>

                <li>
                  the quantum of the loan shall be as set out in the table
                  below:
                </li>

                <table className="my-4 w-1/2 border border-gray-850">
                  <tr className="border border-gray-850">
                    <td className="border-r border-gray-850 pl-8">
                      Country of incorporation / formation of the winner or the
                      winner&apos;s subsidiary, partnership or sole
                      proprietorship that is receiving the loan, where
                      applicable
                    </td>
                    <td className="px-8 align-top">
                      “Emerging Enterprise Award” and the “Emerging Enterprise
                      Sustainability Award”
                    </td>
                  </tr>

                  <tr className="border border-gray-850">
                    <td className="border-r border-gray-850 pl-8">Singapore</td>
                    <td className="px-8">SGD 200,000</td>
                  </tr>

                  <tr className="border border-gray-850">
                    <td className="border-r border-gray-850 pl-8">Malaysia</td>
                    <td className="px-8">MYR 600,000</td>
                  </tr>

                  <tr className="border border-gray-850">
                    <td className="border-r border-gray-850 pl-8">Hong Kong</td>
                    <td className="px-8">HKD 1,000,000</td>
                  </tr>

                  <tr className="border border-gray-850">
                    <td className="border-r border-gray-850 pl-8">Indonesia</td>
                    <td className="px-8">IDR 2,000,000,000</td>
                  </tr>
                </table>

                <li>
                  the loan shall be interest free for 24 months from the date of
                  the loan disbursement;
                </li>

                <li>
                  no interest, processing and annual fees will be charged for 24
                  months from the date of loan disbursement.
                </li>

                <li>
                  disbursement of the term loan shall only be made into a
                  business account with OCBC Bank or the relevant OCBC
                  Subsidiary which is providing the term loan, as the case may
                  be;
                </li>

                <li>
                  if the winner of the relevant Award is not incorporated or
                  formed in Singapore, Malaysia, Indonesia and/or Hong Kong,
                  they must incorporate a subsidiary (if the winner is a company
                  or an LLP), establish a partnership (if the winner is a
                  partnership) or establish a sole proprietorship (if the winner
                  is a sole proprietorship) in any of these countries to receive
                  the term loan;
                </li>

                <li>
                  disbursement of the term loan shall be completed by the end of
                  February of the year following the year in which our winning
                  of the Award was announced. Otherwise, the award of a term
                  loan shall be deemed to be forfeited by us and neither we nor
                  the subsidiary, partnership or sole proprietorship established
                  by us for the purposes of receiving the loan will be entitled
                  to any further loan from OCBC Bank or any OCBC Subsidiary;
                </li>

                <li>
                  the term loan shall not be transferred or assigned by us or
                  our newly-established subsidiary, partnership or sole
                  proprietorship, as the case may be (where such subsidiary,
                  partnership or sole proprietorship is receiving the term loan
                  instead of the winner), to any other individual or entity.
                </li>

                <li>
                  the terms set out above are not exhaustive and the full and
                  final terms of the term loan shall be subject to the final
                  letter of offer issued to us; and
                </li>

                <li>
                  we shall provide and procure (as applicable) the provision of
                  all additional information and / or documents as may be
                  requested by OCBC Bank or the relevant OCBC Subsidiary which
                  is providing the term loan, as the case may be, for the
                  purposes of processing and providing the Award, including
                  without limitation:
                  <ul className="list-outside list-[lower-alpha] pl-8">
                    <li>
                      income documents relating to me / us / relevant persons in
                      our business;
                    </li>

                    <li>
                      personal guarantees (or their equivalent in the relevant
                      jurisdiction) from me / us / relevant persons in our
                      business
                    </li>

                    <p className="mb-0">
                      we shall provide and procure (as applicable) the provision
                      of all relevant consents as may be requested by OCBC Bank
                      or the relevant OCBC Subsidiary which is providing the
                      term loan, as the case may be, for the purposes of
                      processing and providing the Award, including without
                      limitation:
                    </p>

                    <ul className="list-outside list-[lower-alpha] pl-8">
                      <li>
                        consent for OCBC Bank or the relevant OCBC Subsidiary
                        which is providing the term loan, as the case may be, to
                        conduct credit checks on me / us / our business;
                      </li>

                      <li>
                        consent for OCBC Bank or the relevant OCBC Subsidiary
                        which is providing the term loan, as the case may be, to
                        conduct litigation checks on me / us / our business.
                      </li>
                    </ul>
                  </ul>
                </li>
              </ul>
            </li>

            <li>
              the “RSM Consulting Package for Growing Business” (the “Consulting
              Package”) shall be subject to the following conditions:
              <ul className="list-outside list-[upper-roman] pl-8">
                <li>
                  the Consulting Package will only be provided to the winning
                  company and excludes any other company in its group of
                  companies, or its related companies;
                </li>

                <li>
                  the redemption of the Consulting Package shall not be
                  applicable for the assurance, tax advisory and valuation
                  advisory services;
                </li>

                <li>
                  the Consulting Package is non transferable, not exchangeable
                  for cash and must be utilised within 6 months of the Award;
                  and
                </li>

                <li>
                  the final acceptance of any engagement by RSM pursuant to the
                  Consulting Package shall be subject to us complying with
                  RSM&apos;s internal requirements on client acceptance
                  procedures (as prescribed by RSM).
                </li>
              </ul>
            </li>
          </ul>
        </li>

        <li>
          These terms & conditions shall be governed by the laws of Singapore.
          The courts of Singapore shall have exclusive jurisdiction to settle
          any dispute, controversy or claim arising from or in connection with
          these terms & conditions and/or the Emerging Enterprise Award or the
          Emerging Enterprise Sustainability Award.
        </li>
      </ul>
    </div>
  );
};

export default TermsAndConditions;
